import React from 'react'
import Slider from '../componets/Slider';
import a_img from '../img/about-01.jpg'
import mp from "../img/icon/mp.jpeg";
import ar from "../img/icon/ar.jpeg";
import indes from "../img/icon/i-d.jpeg";
import l1 from '../img/latest-new/04.jpg';
import l2 from '../img/latest-new/005.jpg'
import LogoSliderimg from '../componets/imageSlider';
import Testimonials from '../componets/testimonial/Testimonial';
import LogoSlider from '../componets/logosliderimg/LogoSlider';
import { Link } from 'react-router-dom';

const Allpages = () => {
	return (
		<div className="">
			<div className="home">
				<div className="container">
					<div className="row">
						<div className="col-lg-12">
							<Slider />
						</div>
					</div>
				</div>
			</div>
			<div className="rev-spacer"></div>
			<section className="p-t-10 p-b-55">
				<div className="container">
					<div className="media-about">
						<div className="row">
							<div className="col-lg-7">
								<div className="media__body">
									<h5 className="title-sub">about us</h5>
									<h2 className="title-1">
										We are specialists in the field of architecture
									</h2>
									<p className="media__text">
										A young, innovative Design Studio, dedicated in designing
										&amp; planning environmentally friendly buildings, laying
										its focus mainly on Quality Architecture at Global
										Standards. With extreme concern to reflect combination of
										Local Architecture with Post-Modern Simplicity is fairly
										evident in all work. A young dedicative team, that is always
										there to fully meet client requirements &amp; also creating
										a unique identity for their projects.
									</p>
									<a className="au-btn au-btn--arrow" href="about-us.html">
										Read more
										<i className="zmdi zmdi-arrow-right ic-arrow"></i>
									</a>
								</div>
							</div>
							<div className="col-lg-5">
								<div className="media__img js-line">
									<img src={a_img} alt="About" className="ab1" />
									<span className="line active"></span>
									<span className="line line-bottom active"></span>
									<div
										className="media__img-inner wow fadeIn"
										data-wow-duration="0.8s"
										data-wow-delay="0.2s"
									>
										<span className="number">25</span>
										<span className="desc">years of experience</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<section className="p-t-60 p-b-55" id="bg-c-s">
				<div className="container">
					<div className="section-title">
						<h5 className="title-sub">what we do</h5>
						<h2 className="title-1">Our specilization</h2>
					</div>
					<div className="row no-gutters">
						<div className="col-md-6 col-lg-4">
							<article className="media media-service">
								<figure className="media__img mb-0">
									<img src={mp} alt="Master-planning" className="o-s-p-img" />
								</figure>
								<div className="media__title ">
									<h3 className="title">
										<a href="#">Master Planning</a>
									</h3>
									<span className="number">01</span>
								</div>
								<p className="media__text">
									We specialize in delivering exceptional Architectural Design
									Services across Residential, Commercial, and Hospitality
									sectors, while also catering to a wide range of other
									industries. Our innovative and client-focused approach ensures
									functional, aesthetic, and sustainable solutions tailored to
									each project’s unique needs.
								</p>
							</article>
						</div>
						<div className="col-md-6 col-lg-4">
							<article className="media media-service">
								<figure className="media__img mb-0">
									<img src={ar} alt="architecture" className="o-s-p-img" />
								</figure>
								<div className="media__title">
									<h3 className="title">
										<a href="#">architecture</a>
									</h3>
									<span className="number">02</span>
								</div>
								<p className="media__text">
									We specialize in providing comprehensive Master Planning
									Design Services, delivering innovative and sustainable
									solutions tailored to each project’s unique vision and
									requirements. Our strategic approach ensures seamless
									integration of functionality, aesthetics, and long-term value,
									creating vibrant and resilient communities.
								</p>
							</article>
						</div>

						<div className="col-md-6 col-lg-4">
							<article className="media media-service">
								<figure className="media__img mb-0">
									<img
										src={indes}
										alt="Interior-design"
										className="o-s-p-img"
									/>
								</figure>
								<div className="media__title">
									<h3 className="title">
										<a href="#"> Interior design</a>
									</h3>
									<span className="number">03</span>
								</div>
								<p className="media__text">
									We specialize in transforming spaces with innovative Interior
									Design Services that blend style, comfort, and functionality.
									From stunning makeovers to personalized designs, we create
									spaces that reflect your personality and lifestyle, making
									every room uniquely yours—beautiful, practical, and truly
									inspiring.
								</p>
							</article>
						</div>
					</div>
				</div>
			</section>
			<section className="p-top-60 p-bo-55" id="bg-c-s1">
				<div className="container">
					<div className="section-title">
						<h5 className="title-sub">our work</h5>
						<h2 className="title-1">Latest project</h2>
					</div>
					<div className="row no-gutters">
						<div className="col-md-12 col-lg-12">
							<LogoSliderimg />
						</div>
					</div>
				</div>
			</section>
			{/* testimonial */}
			<section className="testimonial">
				<Testimonials />
			</section>
			<section className="bg-colore">
				<LogoSlider />
			</section>
			<section className="blog-latest">
				<div className="container">
					<div className="section-title">
						<h5 className="title-sub">our work</h5>
						<h2 className="title-1">Latest project</h2>
					</div>
					<div className="row no-gutters1">
						<div className="col-md-12 col-lg-6">
							<figure className="entry-image  img-hover-zoom">
								<img src={l2} alt="" />
							</figure>

							<h3>
								<Link to="" className="blog">
									Why do we keep building glass skyscrapers?
								</Link>
							</h3>
							<p className="blog-p">
								Despite criticisms about their environmental impact, glazed
								skyscrapers continue to spring up in cities around the world.
								Jon Astbury investigates why they remain so popular. In 2011,
								British architect Ken Shuttleworth – who designed the Gherkin
								while at Foster + Partners – declared that "the tall glass box
								is dead".
							</p>
						</div>
						<div className="col-md-12 col-lg-6">
							<figure className="entry-image img-hover-zoom">
								<img src={l1} alt="" className="entry-image1" />
							</figure>

							<h3>
								<Link to="" className="blog">
									The Future of Sustainable Architecture: Trends and Innovations
								</Link>
							</h3>
							<p className="blog-p">
								Sustainable architecture is an approach to designing buildings
								that prioritizes environmental sustainability and social
								responsibility. It involves creating structures that minimize
								negative impacts on the environment and maximize positive
								impacts on occupants and communities.
							</p>
						</div>
					</div>
				</div>
			</section>
		</div>
	);
}

export default Allpages